import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const MovementReportsPage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/reports/movements/workOrders`);
    }
  }, [match]);

  return null;
};

export default MovementReportsPage;
